import '@/styles/globals.scss';
import '@/styles/reset.css';
import Head from 'next/head';
import { useEffect } from 'react';
// import { WKGatherer } from '@wk/wk-gatherer';
import type { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import Script from 'next/script';

function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    import('@wk/wk-gatherer').then(({ init }) => {
      init({
        env: (process.env.NEXT_PUBLIC_STAGE || 'test') as 'test' | 'prod',
        data: { ak: 'landing' },
        interval: 1000 / 6,
      });
    });
    console.log('env-->', process.env.NEXT_PUBLIC_VERCEL_ENV, process.env.VERCEL_ENV, process.env.NEXT_PUBLIC_STAGE);

    // 加载eruda控制台 （ios会缓存提前页面资源， require并不会加载 换一种方式才加载eruda）
    if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production' || /eruda=true/.test(window?.location?.href)) {
      (function () {
        const script = document.createElement('script');
        script.src = '//cdn.jsdelivr.net/npm/eruda';
        document.body.appendChild(script);
        script.onload = function () {
          window.eruda?.init();
        };
      })();
    }
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"
        />
        <link rel="dns-prefetch" href="https://cdnwukong.com" />
        <script>this.globalThis || (this.globalThis = this)</script>
        {process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production' && (
          <script
            dangerouslySetInnerHTML={{
              __html: `
              (function() {
                var desc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
                            Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
                if (desc && desc.set) {
                  Object.defineProperty(document, 'cookie', {
                    get: function() { return desc.get.call(this); },
                    set: function(val) {
                      if (typeof val === 'string' && val.indexOf('NEXT_LOCALE') !== -1) {
                        console.warn('[COOKIE-TRACE] NEXT_LOCALE write:', val.substring(0, 80));
                        console.trace('[COOKIE-TRACE] stack');
                      }
                      return desc.set.call(this, val);
                    },
                    configurable: true
                  });
                }
              })();
            `,
            }}
          />
        )}
      </Head>
      <Script src="/js/jweixin-1.6.0.js" />
      <Component {...pageProps} />
    </>
  );
}

export default appWithTranslation(App);
